<template>
  <v-container fluid ma-0 pa-0>
    <v-system-bar v-if="false" window dark app color="primary">
      <v-icon>mdi-shield-check</v-icon>
      <!--       <span v-if="suscripcion"
        >Información de la Licencia: Tipo: {{ suscripcion.tipo }} / Finaliza:
        {{ suscripcion.fechaFinSuscripcion | moment("DD-MM-YYYY") }}</span
      >-->
      <span>Su periodo de prueba ha finalizado</span>
      <v-spacer></v-spacer>
      <!-- <v-icon>mdi-delete</v-icon>
      <v-icon>mdi-chevron-down</v-icon>
      <v-icon>mdi-close</v-icon>-->
    </v-system-bar>
    <v-app-bar app elevation="0" color="indigo lighten-5">
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      <img src="@/assets/logo.svg" style="height:40px" />

      <div class="d-flex align-center"></div>
      <v-spacer />
      <!--   <v-btn rounded elevation="0" color="primary" dark class="mr-2">Iniciar Sesión</v-btn> -->
      <sign-out-button />
    </v-app-bar>
    <!--  <v-app-bar color="primary" dark>
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>

      <v-toolbar-title>Title</v-toolbar-title>
    </v-app-bar>-->

    <v-navigation-drawer
      absolute
      permanent
      clipped
      :expand-on-hover="true"
      left
    >
      <v-list dense>
        <!--<v-list-item two-line>
            <v-list-item-avatar>
              <img src="https://randomuser.me/api/portraits/men/81.jpg" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Luis Narea</v-list-item-title>
              <v-list-item-subtitle
                >luis.narea@inteldatos.com</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item> 

        <v-divider></v-divider>-->
        <template v-for="item in items">
          <v-layout v-if="item.heading" :key="item.heading" align-center>
            <v-flex xs6>
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-flex>
            <v-flex xs6 class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            :key="item.name"
            v-model="item.model"
            :prepend-icon="item.model ? item.meta.icon : item.meta['icon-alt']"
            append-icon
            v-permission="item.meta.roles"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ item.meta.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              v-bind:class="currentRouteClassObject(child.path)"
              :key="i"
              @click="goTo(child.path)"
            >
              <v-list-item-action v-if="child.meta.icon">
                <v-icon>{{ child.meta.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.meta.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.name"
            @click="goTo(item.path)"
            v-bind:class="currentRouteClassObject(item.path)"
            v-permission="item.meta.roles"
          >
            <v-list-item-action v-if="item.meta.icon">
              <v-icon>{{ item.meta.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.meta.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- Provides the application the proper gutter -->
    <v-container fluid pl-16>
      <!-- If using vue-router -->
      <router-view></router-view>
    </v-container>
  </v-container>
</template>

<script>
//import layoutRouter from "@/router/modules/layout"
//import AnimateBadge from "@/components/AnimateBadge";
import SignOutButton from '@/components/buttons/SignOutButton';
export default {
  components: {
    SignOutButton
  },
  data: () => ({
    drawer: false,
    currentItem: 'tab-Web',
    items: ['Web', 'Shopping', 'Videos', 'Images'],
    more: ['News', 'Maps', 'Books', 'Flights', 'Apps']
  }),
  methods: {
    addItem(item) {
      const removed = this.items.splice(0, 1);
      this.items.push(...this.more.splice(this.more.indexOf(item), 1));
      this.more.push(...removed);
      this.$nextTick(() => {
        this.currentItem = 'tab-' + item;
      });
    },
    goTo: function(to) {
      this.$router.push(to);
    },
    currentRouteClassObject: function(to) {
      return {
        'current-view': to === this.currentRoute,
        'not-current-view': to != this.currentRoute
      };
    }
  },
  computed: {
    routes() {
      return this.$router.options.routes;
    }
  },
  created() {
    console.log(this.routes);
    this.items = this.$router.options.routes.find(
      element => element.path == '/'
    ).children;
  }
};
</script>
